import React from 'react';

import { BreadcrumbConteiner, BreadcrumbItem, Container } from './styles';

export interface Item {
  depth: number;
  text: string;
  id: number;
}

interface BreadcrumbProps {
  path: Item[];
}

const Breadcrumb: React.FC<BreadcrumbProps> = ({ path }) => {
  const sortedItems = [...path].sort((a, b) => a.depth - b.depth);

  return (
    <Container>
      {path.length > 0 && (
        <BreadcrumbConteiner data-testid="breadcrumb-container">
          {sortedItems.map((item, i) => (
            <BreadcrumbItem data-testid={`breadcrumb-item`} key={i}>
              {item.text}
            </BreadcrumbItem>
          ))}
        </BreadcrumbConteiner>
      )}
    </Container>
  );
};

export default Breadcrumb;
